// extracted by mini-css-extract-plugin
module.exports = {"myModal":"MyModal_myModal__Wk8Wq","myModalContent":"MyModal_myModalContent__1MeUu","active":"MyModal_active__Sde6s"};